import { ButtonDropdown, Flex, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { BankTransactionSortProperty } from '@features/bankTransactions/enums/bankTransactionSortProperty'

import { SortDirection } from '../../../../../../../../../../../enums/sortDirection'
import { getDrawerListSortOptions, SortValue } from '../../../../../utils/getDrawerListSortOptions'

interface TransactionsListSortProps {
  onSortChange: (sortProperty: BankTransactionSortProperty, sortDirection: SortDirection) => void
  sortProperty: BankTransactionSortProperty
  sortDirection: SortDirection
}

export const TransactionsListSort = ({
  onSortChange,
  sortProperty,
  sortDirection,
}: TransactionsListSortProps): ReactElement => {
  const { t } = useTranslation()

  const sortOption = `${sortProperty}_${sortDirection}`

  const sortItems = useMemo(
    () =>
      getDrawerListSortOptions({
        amountProperty: BankTransactionSortProperty.Amount,
        dateProperty: BankTransactionSortProperty.EntryDate,
        t,
      }),
    [t],
  )

  const handleSortChange = useCallback(
    (_id?: string, value?: SortValue<BankTransactionSortProperty>) => {
      if (value) {
        onSortChange(value.sortProperty, value.sortDirection)
      }
    },
    [onSortChange],
  )

  return (
    <Flex alignItems="center">
      <Text>{t('bank_transactions.drawer.sort_by_label')}:</Text>
      <Space size="s8" />
      <ButtonDropdown
        items={sortItems}
        selectedId={sortOption}
        onSelect={handleSortChange}
        variant="text"
        dropdownId="transactions-list-sort-dropdown"
        placement="bottom-start"
      />
    </Flex>
  )
}
